import {createAsyncThunk} from '@reduxjs/toolkit'
import {accountsApi} from './accountsApi'

const normalizeRole = role => String(role || '').toLowerCase()

const toRoleList = roles =>
  Array.isArray(roles) ? roles : roles ? [roles] : []

const LEGACY_MY_ACCOUNT_ROLES = new Set(['reseller', 'yello', 'aussalesusers'])

const getEffectiveRoles = state => {
  const {actualRole, switchedRole, isSwitchRoleUser} = state.userRole || {}
  return toRoleList(
    isSwitchRoleUser && switchedRole ? switchedRole : actualRole,
  )
}

export const fetchAccounts = createAsyncThunk(
  'accounts/fetchAccounts',
  async ({client, email, thryvId, eaid}, {rejectWithValue}) => {
    try {
      return await accountsApi.getAccounts(client, {email, thryvId, eaid})
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const fetchSubscriptions = createAsyncThunk(
  'accounts/fetchSubscriptions',
  async ({client, thryvId}, {rejectWithValue}) => {
    try {
      return await accountsApi.getSubscriptions(client, {thryvId})
    } catch (err) {
      return rejectWithValue(
        err?.response?.data ?? 'Failed to fetch subscriptions',
      )
    }
  },
)

export const fetchMyAccounts = createAsyncThunk(
  'accounts/fetchMyAccounts',
  async (
    {client, offset = 0, limit = 20, keapPartnerId, search},
    {getState, rejectWithValue},
  ) => {
    try {
      const roles = getEffectiveRoles(getState())
      const useLegacyMyAccounts = roles.some(role =>
        LEGACY_MY_ACCOUNT_ROLES.has(normalizeRole(role)),
      )

      // Keap partners are attributed by keapPartnerId, not rep email - use the
      // partner-scoped endpoint when an id is present, else the rep endpoint.
      return keapPartnerId
        ? await accountsApi.getPartnerAccounts(client, {
            keapPartnerId,
            offset,
            limit,
            search,
          })
        : useLegacyMyAccounts
        ? await accountsApi.getLegacyMyAccounts(client, {offset, limit, search})
        : await accountsApi.getMyAccounts(client, {offset, limit, search})
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? 'Failed to fetch accounts')
    }
  },
)
